// Home Accordion

document.querySelectorAll('.Accordion-head').forEach(function(accordionHead) {
    accordionHead.addEventListener('click', function(e) {
        e.preventDefault();

        let accordionBody = this.nextElementSibling;

        if (accordionBody.classList.contains('show')) {
            accordionBody.classList.remove('show');
            accordionBody.style.display = 'none';
            this.querySelector('h3').classList.remove('active');
            this.querySelector('.open').classList.remove('active');
            this.querySelector('.close').classList.remove('active');
            this.querySelector('.Accordion-circle').classList.remove('active');
        } else {
            let container = this.closest('.Accordion-container');

            if (container) {
                let allAccordionBodies = container.querySelectorAll('.Accordion-body-main');
                allAccordionBodies.forEach(function(body) {
                    body.classList.remove('show');
                    body.style.display = 'none';
                });

                let allHeaders = container.querySelectorAll('.Accordion-head h3, .Accordion-head .open, .Accordion-head .close, .Accordion-head .Accordion-circle');
                allHeaders.forEach(function(header) {
                    header.classList.remove('active');
                });
            }

            accordionBody.classList.add('show');
            accordionBody.style.display = 'block';
            this.querySelector('h3').classList.add('active');
            this.querySelector('.open').classList.add('active');
            this.querySelector('.close').classList.add('active');
            this.querySelector('.Accordion-circle').classList.add('active');
        }
    });
});



// Customers Reviews Slider

$(document).ready(function(){
    $('.Customers-Reviews-slider').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        prevArrow: $('.right-btn'),
        nextArrow:  $('.left-btn')
    });
});


// Social Slider
$(document).ready(function(){
    $('.Social-slider').slick({
        initialSlide: 1,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinity: true,
        arrows: false, 
        autoplay: true,
        autoplaySpeed: true,
        speed: 4000,   
        cssEase: 'linear',  
        centerMode: true,
        centerPadding: '120px',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 3,
                  centerPadding: '60px',
                }
              },
            {
              breakpoint: 991,
              settings: { 
                slidesToShow: 2,
              }
            },
            {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  centerPadding: '0px',
                }
              },
          ]
    });
});


// Certified-Part Silder

$('.CP-slider-big').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.CP-slider-small'
  });
  $('.CP-slider-small').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    infinity: false,
    asNavFor: '.CP-slider-big',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
        {
            breakpoint: 767,
            settings: {
              slidesToShow: 5,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 4,
            }
          },
      ]
  });

// $(document).ready(function() {
//     function validateEmail(email) {
//         var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         return emailPattern.test(email);
//     }

//     $('.btn.footer-email-submit').on('click', function(event) {
//         event.preventDefault();

//         var emailInput = $('.input-group-field.footer-email-input').val();

//         if (emailInput === '') {
//             alert('Please enter an email address.');
//         } 
//         else if (!validateEmail(emailInput)) {
//             alert('Please enter a valid email address.');
//         } 
//         else {
//             $(this).closest('form').submit();
//         }
//     });
// });

const stepOnActive = () => {
    const chooseDate = document.querySelectorAll('ul.calendar-time-main li button');
    const soneHideBtn = document.querySelector(".calendar-form .SContainer>:nth-child(3)");
    const soneNextBtn = document.querySelector(".calendar-form .SContainer>:nth-child(2)");
    const soneStatus = document.querySelector("section.step-section .SContainer>:nth-child(1) .update-btn");

    if (chooseDate.length > 0) {
        chooseDate.forEach((button) => {
            button.addEventListener('click', () => {
                if (button.classList.contains('active')) {
                    button.classList.remove('active');
                    if (soneHideBtn) soneHideBtn.classList.remove("active");
                    if (soneNextBtn) soneNextBtn.classList.remove("active");
                } else {
                    chooseDate.forEach((s) => {
                        s.classList.remove('active');
                    });
                    button.classList.add('active');
                    if (soneHideBtn) soneHideBtn.classList.add("active");
                    if (soneNextBtn) soneNextBtn.classList.add("active");
                }
            });
        });
    }

    if (soneHideBtn) {
        soneHideBtn.addEventListener('click', () => {
            if (soneStatus) {
                soneStatus.classList.add('done');
                soneStatus.textContent = 'Complete';
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', stepOnActive);



// calender js
const calendarScript = () => {
  function generate_year_range(start, end) {
    let years = "";
    for (let year = start; year <= end; year++) {
      years += "<option value='" + year + "'>" + year + "</option>";
    }
    return years;
  }

  let today = new Date();
  let currentMonth = today.getMonth();
  let currentYear = today.getFullYear();

  const selectYear = document.getElementById("year");
  const selectMonth = document.getElementById("month");
  const calendar = document.getElementById("calendar");
  const monthAndYear = document.getElementById("monthAndYear");
  const calendarBody = document.getElementById("calendar-body");

  // Check if the necessary elements exist
  if (!selectYear || !selectMonth || !calendar || !monthAndYear || !calendarBody) {
    console.error("One or more required calendar elements are missing.");
    return; // Exit the function early if elements are missing
  }

  const createYear = generate_year_range(1970, 2050);
  selectYear.innerHTML = createYear;

  const lang = calendar.getAttribute("data-lang");

  let months, days, fullDays;
  const monthDefault = [
    "January", "February", "March", "April", "May", "June", 
    "July", "August", "September", "October", "November", "December"
  ];
  const dayDefault = ["M", "T", "W", "T", "F", "S", "S"];
  const fullDayDefault = [
    "Monday", "Tuesday", "Wednesday", "Thursday", 
    "Friday", "Saturday", "Sunday"
  ];

  if (lang === "en") {
    months = monthDefault;
    days = dayDefault;
    fullDays = fullDayDefault;
  } else if (lang === "id") {
    months = [
      "Januari", "Februari", "Maret", "April", "Mei", "Juni", 
      "Juli", "Agustus", "September", "Oktober", "November", "Desember"
    ];
    days = ["S", "S", "R", "K", "J", "S", "M"];
    fullDays = [
      "Senin", "Selasa", "Rabu", "Kamis", 
      "Jumat", "Sabtu", "Minggu"
    ];
  } else if (lang === "fr") {
    months = [
      "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", 
      "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];
    days = ["L", "M", "M", "J", "V", "S", "D"];
    fullDays = [
      "Lundi", "Mardi", "Mercredi", "Jeudi", 
      "Vendredi", "Samedi", "Dimanche"
    ];
  } else {
    months = monthDefault;
    days = dayDefault;
    fullDays = fullDayDefault;
  }

  let $dataHead = "<tr>";
  for (let dhead in days) {
    $dataHead += "<th data-days='" + days[dhead] + "'>" + days[dhead] + "</th>";
  }
  $dataHead += "</tr>";

  document.getElementById("thead-month").innerHTML = $dataHead;

  showCalendar(currentMonth, currentYear);

  function next() {
    currentYear = (currentMonth === 11) ? currentYear + 1 : currentYear;
    currentMonth = (currentMonth + 1) % 12;
    showCalendar(currentMonth, currentYear);
  }

  function previous() {
    currentYear = (currentMonth === 0) ? currentYear - 1 : currentYear;
    currentMonth = (currentMonth === 0) ? 11 : currentMonth - 1;
    showCalendar(currentMonth, currentYear);
  }

  function jump() {
    currentYear = parseInt(selectYear.value);
    currentMonth = parseInt(selectMonth.value);
    showCalendar(currentMonth, currentYear);
  }

  function showCalendar(month, year) {
    const firstDay = (new Date(year, month).getDay() + 6) % 7;

    calendarBody.innerHTML = "";

    monthAndYear.innerHTML = `${months[month]} ${year}`;
    selectYear.value = year;
    selectMonth.value = month;

    let date = 1;
    for (let i = 0; i < 6; i++) {
      const row = document.createElement("tr");

      for (let j = 0; j < 7; j++) {
        if (i === 0 && j < firstDay) {
          const cell = document.createElement("td");
          const cellText = document.createTextNode("");
          cell.appendChild(cellText);
          row.appendChild(cell);
        } else if (date > daysInMonth(month, year)) {
          break;
        } else {
          const cell = document.createElement("td");
          cell.setAttribute("data-date", date);
          cell.setAttribute("data-month", month + 1);
          cell.setAttribute("data-year", year);
          cell.setAttribute("data-month_name", months[month]);
          cell.setAttribute("data-day_full", fullDays[j]);
          cell.className = "date-picker";
          cell.innerHTML = `<span>${date}</span>`;
          
          if (
            date === today.getDate() &&
            year === today.getFullYear() &&
            month === today.getMonth()
          ) {
            cell.className = "date-picker active";
          }
          if (
              (year < today.getFullYear()) ||
              (year === today.getFullYear() && month < today.getMonth()) ||
              (year === today.getFullYear() && month === today.getMonth() && date < today.getDate())
            ) {
              cell.className = "date-picker disable-btn";
            }

          cell.addEventListener("click", function () {
            const selectedDay = this.getAttribute("data-day_full");
            const selectedDate = this.getAttribute("data-date");
            const selectedMonth = this.getAttribute("data-month_name");
            const detailShow = document.querySelector(".calendar-detail-show p");
            
            if (detailShow) {
              detailShow.textContent = `These are the Available Slots for ${selectedDay}, ${selectedDate} ${selectedMonth}`;
              applyCustomClassesAndLogic();
            } else {
              console.warn(".calendar-detail-show p element is missing.");
            }
          });

          row.appendChild(cell);
          date++;
        }

      }
      calendarBody.appendChild(row);
        
    }

    applyCustomClassesAndLogic();
  }

  function daysInMonth(iMonth, iYear) {
    return 32 - new Date(iYear, iMonth, 32).getDate();
  }

  const prevButton = document.querySelector("#previous");
  const nextButton = document.querySelector("#next");

  if (prevButton && nextButton) {
    prevButton.addEventListener("click", previous);
    nextButton.addEventListener("click", next);
  } else {
    console.warn("Navigation buttons are missing.");
  }

};

document.addEventListener('DOMContentLoaded', calendarScript);


function applyCustomClassesAndLogic() {
  const clickSpan = document.querySelectorAll(".table-calendar td span");
  const soneNextBtn = document.querySelector(".calendar-form .SContainer>:nth-child(2)");
  const soneHideBtn = document.querySelector(".calendar-form .SContainer>:nth-child(3)");
  const soneCount = document.querySelector("section.step-section .SContainer>:nth-child(1) .sb-top-main .count");
  const soneLine = document.querySelector("section.step-section .SContainer>:nth-child(1) .sb-top-main>:nth-child(2)");
  const soneText = document.querySelector("section.step-section .SContainer>:nth-child(1) .sb-top-bottom h5");
  const soneStatus = document.querySelector("section.step-section .SContainer>:nth-child(1) .update-btn");
  const soneShowBottom = document.querySelector(".calendar-detail");
  const asssaa = document.querySelector('.calendar-form .SContainer>:nth-child(3)');

  if (!soneStatus || !asssaa || !soneShowBottom) {
    console.error("Required elements are missing. Check the DOM structure.");
    return;
  }

  asssaa.addEventListener('click', () => {
    soneStatus.classList.add('done');
    soneStatus.textContent = 'Complete';
  });

  clickSpan.forEach((span) => {
    span.addEventListener("click", () => {

      clickSpan.forEach((s) => s.classList.remove("active"));
      span.classList.add("active");


      if (document.querySelector(".table-calendar td span.active")) {
        soneShowBottom.classList.add("active");
        soneCount?.classList.add("active");
        soneLine?.classList.add("active");
        soneText?.classList.add("active");
        soneStatus.classList.add("active");
        soneStatus.textContent = "In Progress";
      } else {
        soneShowBottom.classList.remove("active");
        soneCount?.classList.remove("active");
        soneLine?.classList.remove("active");
        soneText?.classList.remove("active");
        soneStatus.classList.remove("active");
        soneStatus.textContent = "Progress";
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', applyCustomClassesAndLogic);


$('.back-to-prv').on('click', function() {
    window.location.href = 'https://thepartpal.com/pages/choose-date-time';
});



document.addEventListener("DOMContentLoaded", function() {
    const schedule_install_btn = document.getElementById("schedule-install");
    const selected_email_form = document.getElementById("selected-email-form");
    const selected_email_select = document.getElementById("selected-email-div");
    const email_added_input = document.getElementById("email-added");
    const change_email_btn = document.getElementById("change-email");
    const email_address = document.getElementById("email-address");
    const date_pick_email_address = document.getElementById("email-added");


    if (schedule_install_btn && email_added_input && selected_email_form && selected_email_select && email_address) {
        schedule_install_btn.addEventListener("click", function(){
            if(email_added_input.value){
                const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

                if (!emailPattern.test(email_added_input.value)) {
                  alert("Please enter a valid email address.");
                  return;
                }
                
                email_address.textContent = email_added_input.value;
                setCookie("emailAddress", email_added_input.value, 2); 
                email_added_input.value = '';
                selected_email_form.style.display = "none";
                selected_email_select.style.display = "block";        
                const email_cookie = checkCookie('emailAddress');
                const mailChimpBtn = document.getElementById("mc-embedded-subscribe");
                const mailChimpInput = document.getElementById("mce-EMAIL");
                const mailChimpForm = document.getElementById("mc-embedded-subscribe-form");
                mailChimpInput.value = email_cookie;
                mailChimpBtn.click();

            }
          
        });
    }

    if (change_email_btn && selected_email_form && selected_email_select && email_added_input) {
        change_email_btn.addEventListener("click", function(){
            selected_email_form.style.display = "block";
            selected_email_select.style.display = "none";
            const email_value = checkCookie("emailAddress");
            if(email_value){
                email_added_input.value = email_value;
            }
        });
    }

    function setCookie(cname, cvalue) {
        document.cookie = cname + "=" + cvalue + "; path=/"; 
    }

    function checkCookie(cookieName) {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [name, value] = cookie.split("=");
            if (name === cookieName) {
                return value;
            }
        }
        console.error(`Cookie "${cookieName}" not found`);
        return null;
    }


    const cellAll = document.querySelectorAll(".date-picker");
    cellAll.forEach(date => {
        date.addEventListener("click", function() {
            const chooseDay = this.getAttribute("data-day_full");
            const chooseDate = this.getAttribute("data-date");
            const chooseMonth = this.getAttribute("data-month_name");
            const chooseYear = this.getAttribute("data-year");
            const due_date = `${chooseDay}, ${chooseDate} ${chooseMonth} ${chooseYear}`;

            setCookie("dueDate", due_date, 2);
            setCookie("selectedDate", chooseDate, 2);
    
            const days_metadata = JSON.parse(document.querySelector("#days_metadata").textContent);
            const chooseDayMeta = days_metadata[`${chooseDay}`];  

    
            const ulElement = document.getElementById('timeSlotsList');
            ulElement.innerHTML = ''; 
    
            chooseDayMeta.map(timeslot => {
                const liElement = document.createElement('li');
                const buttonElement = document.createElement('button');
                buttonElement.type = 'button';
                buttonElement.textContent = timeslot;
                liElement.appendChild(buttonElement);
                ulElement.appendChild(liElement);
            });


           const timeSlot = document.querySelectorAll(".calendar-time-main li button");
              timeSlot.forEach(time => {
                  time.addEventListener("click", function(){
                      ulElement.querySelectorAll("button").forEach(btn => btn.classList.remove("active"));
                      this.classList.add("active")
                      setCookie("dueTime", this.textContent, 2);
                  });
              });

        });
    });
    
      const order_fulfilment_date = document.getElementById("order-fulfilment-date");
      const order_fulfilment_time = document.getElementById("order-fulfilment-time");
      const dueDate_value = checkCookie("dueDate");
      const dueTime_value = checkCookie("dueTime");
      if(dueDate_value){
          order_fulfilment_date.value = dueDate_value;
      }
      if(dueTime_value){
        order_fulfilment_time.value = dueTime_value;
      }
});

const date_pick_email_address = document.getElementById("email-added");

document.getElementById('schedule-install').addEventListener('click', function(e) {

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!date_pick_email_address.value || !emailRegex.test(date_pick_email_address.value)) {
    alert("Please enter a valid email address.");
    e.preventDefault();
  }
});

$(document).ready(function() {
    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
    }

    const email = getCookie('emailAddress');
    const date = getCookie('dueDate');
    const time = getCookie('dueTime');
    var currentUrl = window.location.href;
    var homeUrl = "https://thepartpal.com/pages/choose-date-time";
  console.log(email, date, time);
  // && !currentUrl.includes("editor") && !currentUrl.includes("admin.shopify.com")
    
    if (!email) {
        if (currentUrl.includes("/collections") || currentUrl.includes("/products") || currentUrl.includes("/cart") && currentUrl !== homeUrl) {
            window.location.href = homeUrl; 
        }
    } else {
        $('#selected-email-form').css('display', 'none');
        $('#selected-email-div').css('display', 'block');
        $('.email-address').text(email);
    }

    $('.step-1').on('click', function() {
        window.location.href = 'https://thepartpal.com/collections/partspal';
    });

    

  if (email && date && time) {
    document.querySelector('.step-1').previousElementSibling.style.display =" none";
    document.querySelector('.step-1').style.display =" block";
  }

window.addEventListener('load', function() {
  const selectedDate = getCookie('selectedDate');
  const selectedTime = getCookie('dueTime');
  const datePicker = document.querySelectorAll(".date-picker");

  datePicker.forEach(date => {
    const checkDateInterval = setInterval(function() {
      const dateElement = document.querySelector(`[data-date="${selectedDate}"]`);
      
      if (dateElement) {
        dateElement.querySelector("span").click();
        clearInterval(checkDateInterval);

        const checkTimeInterval = setInterval(function() {
          const timePicker = document.querySelectorAll("#timeSlotsList button");
          
          if (timePicker.length > 0) { 
            timePicker.forEach(time => {
              if (time.textContent.trim() === selectedTime) {
                time.click();
                clearInterval(checkTimeInterval); 
              }
            });
          }
        }, 500);
      }
    }, 500); 
  });
});


function checkAndToggleStep() {
    const email = getCookie('emailAddress');
    const date = getCookie('dueDate');
    const time = getCookie('dueTime');
    
  if (email && date && time) {
    document.querySelector('.step-1').previousElementSibling.style.display = "none";
    document.querySelector('.step-1').style.display = "block";
  }
}

const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes' || mutation.type === 'childList' || mutation.type === 'subtree') {
      checkAndToggleStep();
    }
  }
});
  

const targetNode = document.body; 

const config = { attributes: true, childList: true, subtree: true };

observer.observe(targetNode, config);

});


